import { render, staticRenderFns } from "./PromoStatusView.vue?vue&type=template&id=5c3c6b48&"
import script from "./PromoStatusView.vue?vue&type=script&lang=js&"
export * from "./PromoStatusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3c6b48')) {
      api.createRecord('5c3c6b48', component.options)
    } else {
      api.reload('5c3c6b48', component.options)
    }
    module.hot.accept("./PromoStatusView.vue?vue&type=template&id=5c3c6b48&", function () {
      api.rerender('5c3c6b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promo/PromoStatusView.vue"
export default component.exports